import { useQueries } from '@tanstack/react-query'

import { useActiveJourneySubscriptionsQuery } from '@/src/features/community/services/useActiveJourneySubscriptionsQuery'
import { ErrorMessage } from '@/src/general/components/ErrorMessage'

import { COMMUNITY_ACTIVITY } from '../../../models/community.constants'
import { communityQueryOptions } from '../../../services/useCommunityQuery'
import { useDoneCommunitiesQuery } from '../../../services/useDoneCommunitiesQuery'
import { JourneySliderBase } from './JourneySliderBase'
import type { TJourneyThumbnailProps } from './JourneyThumbnail'

export const JourneySlider = () => {
  const { data, error } = useActiveJourneySubscriptionsQuery()
  const { data: doneCommunities } = useDoneCommunitiesQuery()

  const subscriptions = data?.sort((a, b) => (a.fromDate && b.fromDate ? a.fromDate.localeCompare(b.fromDate) : 0))

  const journeyItems = useQueries({
    queries: subscriptions ? subscriptions.map(({ community }) => communityQueryOptions(community.id)) : [],
    combine: (results) => {
      if (!subscriptions) return undefined
      return results.reduce<TJourneyThumbnailProps[]>((acc, result, index) => {
        const { community: subscriptionCommunity, ...subscriptionDetails } = subscriptions[index]
        if (result.isError) return acc

        const community = result.data || {
          // Known community values with best default values as fallback while publication query is loading
          activity: COMMUNITY_ACTIVITY.ACTIVE,
          isPrivate: false,
          nbMembers: 0,
          picture: '',
          slug: '',
          ...subscriptionCommunity,
        }

        acc.push({
          community,
          subscription: subscriptionDetails,
        })
        return acc
      }, [])
    },
  })

  if (error) return <ErrorMessage error={error} defaultErrorKey="prayer-space.journey.load.error" />

  return <JourneySliderBase journeyItems={journeyItems} showHistoryButton={!!doneCommunities?.length} />
}
